import { FieldRuleSet } from './field-rule-set';

/**
 * Validation configuration for CustomRules mode. Contains an array of FieldRuleSets,
 * each targeting a specific field with its own IfRuleGroup condition.
 */
export class CustomRules {
	/**
	 * Array of field-level rule sets to evaluate per record.
	 * @default []
	 */
	fieldRuleSets: FieldRuleSet[] = [];

	constructor(init?: Partial<CustomRules>) {
		if (init) {
			Object.assign(this, init);
		}
	}
}
